/**
 * UX 4: Consistent sidebar navigation for all /startups/:id/* sub-pages
 * Mirrors the dashboard sidebar structure.
 */
import { Link, useParams, useLocation } from 'react-router-dom';
import { ClipboardList, BarChart2, LineChart, FlaskConical, MessageSquare } from 'lucide-react';

const NAV_ICON: Record<string, React.ReactNode> = {
  '': <ClipboardList size={15} />,
  '/dashboard': <BarChart2 size={15} />,
  '/financials': <LineChart size={15} />,
  '/beta': <FlaskConical size={15} />,
  '/feedback': <MessageSquare size={15} />,
};

const NAV_ITEMS = [
  { path: '', label: 'Overview' },
  { path: '/dashboard', label: 'Dashboard' },
  { path: '/financials', label: 'Financials' },
  { path: '/beta', label: 'Beta Users' },
  { path: '/feedback', label: 'Feedback' },
];

export function StartupSubNav({ children }: { children: React.ReactNode }) {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const basePath = `/startups/${id}`;

  return (
    <div style={{ display: 'flex', gap: 0, alignItems: 'flex-start', margin: '0 -16px' }}>
      <aside style={{
        width: 200, flexShrink: 0, position: 'sticky', top: 80,
        maxHeight: 'calc(100vh - 80px)', overflowY: 'auto',
        padding: '16px 12px', borderRight: '1px solid #2a2a3e',
      }}
        className="hidden lg:block"
      >
        <div style={{ fontSize: 10, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 1.5, padding: '4px 10px', marginBottom: 8 }}>
          Navigation
        </div>
        {NAV_ITEMS.map(item => {
          const fullPath = `${basePath}${item.path}`;
          const isActive = item.path === ''
            ? location.pathname === basePath
            : location.pathname.startsWith(fullPath);
          return (
            <Link
              key={item.path}
              to={fullPath}
              style={{
                display: 'flex', alignItems: 'center', gap: 8, width: '100%',
                padding: '8px 10px', borderRadius: 8,
                background: isActive ? '#2a2a3e' : 'transparent',
                color: isActive ? '#fff' : '#9ca3af',
                fontSize: 13, fontWeight: isActive ? 600 : 400,
                textDecoration: 'none', marginBottom: 2,
                transition: 'background 0.15s, color 0.15s',
              }}
            >
              <span style={{ display: 'flex', flexShrink: 0 }}>{NAV_ICON[item.path]}</span>
              <span>{item.label}</span>
            </Link>
          );
        })}
      </aside>
      <main style={{ flex: 1, padding: '0 16px', minWidth: 0 }}>
        {children}
      </main>
    </div>
  );
}
